export function setActiveAlerts(realtime: boolean | undefined, daily: boolean | undefined, weekly: boolean | undefined) {
  return !realtime && !daily && !weekly;
}

export function setActiveDigestAlerts(digestDaily: boolean | undefined, digestWeekly: boolean | undefined) {
  return !digestDaily && !digestWeekly;
}
